<template>
        <g-card :expansivel="false" :temCabecalho="false">
            <div class="cabecalho-formulario">
                <div class="titulo-formulario titulo-formulario-reclamacao" v-if="this.$route.params.id != ''"> Edição de Grupo </div>
                <div class="titulo-formulario titulo-formulario-reclamacao" v-if="this.$route.params.id == ''"> Cadastro de Grupo </div>
            </div>

            <g-form>
                <div class="titulo-popup-finalizado" v-if="this.$route.params.id == ''" > PREENCHA AS INFORMAÇÕES ABAIXO </div>
                <div class="conteudo-formulario-reclamacao espacamento-formulario">
                    <div class="grupo-dados-nome-lider">
                        <div class="dados-nome">
                            <div class="titulo-conteudo-filtros"> Nome do Grupo <strong class="asterisco-obrigatorio">*</strong></div>              
                            <PInputText                          
                            v-model="NomeGrupo" 
                            maxlength="50" 
                            >
                            </PInputText>
                        </div>

                        <div class="dados-lider">
                            <div class="titulo-conteudo-filtros"> Líder Do Grupo</div>              
                            <PDropDown
                                v-model="UsuarioLiderId"
                                :options="UsuarioArray"
                                optionLabel="nomeUsuario"
                                optionValue="id"
                                @filter="buscarUsuario($event.value)"
                                :filter="true"
                                placeholder="Selecione o Usuário"
                                />
                        </div>




                    </div>

                    <div class="linha-separacao"></div>

                    <div class="grupo-sequencia-conteudo"> 
                                    <div class="titulo-linha">
                                        <div class="titulo-grupo titulo-popup-finalizado"> Usuários vinculados ao grupo (Qtde mínima: sem restrição / Qtde máxima: sem restrição)</div>
                                    </div>
                                    <div class="tipo-nome-produto">

                                        <div class="sequencia-produto-button">
                                            <div class="sequencia-produto">
                                                <div class="titulo-conteudo-filtros"> Usuário </div>
                                                <PDropDown
                                                v-model="UsuarioId"
                                                :options="UsuarioArrayGrid"
                                                optionLabel="nomeUsuario"
                                                optionValue="id"
                                                @filter="buscarUsuarioGrid($event.value)"
                                                :filter="true"
                                                placeholder="Selecione o Usuário"
                                                />
                                            </div>                                    
                                            <div class="sequencia-adicionar-produto-mobile">
                                                <g-button
                                                tipo="amarelo"
                                                altura = "40px"
                                                largura = "80px"
                                                :somenteIcone="true"
                                                :sombreado="false"
                                                @click="AdicionarUsuarioAoGrid"
                                                >
                                                    <i class="pi pi-plus"></i>
                                                </g-button>                                        
                                            </div>
                                        </div>
                                    </div>
                                </div>

                <div class="sequencia-datatable">
                    <g-data-table
                    TextoVazio="Nenhum Usuário Selecionado"
                    Titulo="Usuários Vinculados"
                    v-on:excluir="VerificaQuantidadeGrupoPorUsuario"
                    :colunas="Colunas"
                    :valores="UsuariosVinculados"
                    :NumeroLinhas="8"
                    :Editavel="false"
                    :Excluivel="true"
                    ></g-data-table>
                </div>

                </div>
            </g-form>

            <div class="buttons-next-back">
                <div class="button-next">
                    <g-button
                    tipo="amarelo" 
                    negritoTexto 
                    altura="35px"
                    largura="100%"
                    @click="gravar"
                    >
                        GRAVAR
                    </g-button>
                </div>
                <div class="button-back">
                    <g-button 
                    tipo="cinza" 
                    altura="35px"
                    largura="100%"
                    negritoTexto 
                    @click="this.$router.push('/gerenciamento-grupos')"
                    >
                        VOLTAR
                    </g-button>
                </div>
            </div>

          <PDialog :showHeader="false" :closable="false" v-model:visible="popup" :modal="true">
          <div class="titulo-popup-finalizado"> Formulário {{this.NumeroFormulario}} gerado com sucesso! </div>
          <div class="botoes-popup">
            <div>
              <g-button
              tipo="cinza"
              negritoTexto 
              largura="200px" 
              altura="35px" 
              @click="consultarFormulario"
              >
              CONSULTAR
              </g-button>
            </div>
          </div>
        </PDialog>
        </g-card>
</template>

<script>
import AdicionarGrupo from './AdicionarGrupo.js' 
export default AdicionarGrupo
</script>

<style scoped>
.sequencia-datatable{
    margin-top: 1.5rem;
}
.titulo-grupo {
    font-size: 16px;
    text-align: left;
}
.sequencia-adicionar-produto-mobile {
    display: flex;
    margin-top: 2rem;
}
.sequencia-produto-button {
    display: flex;
    gap: 10px;
}
.sequencia-produto {
    width: 100%;
}

.dados-nome{
    width: 100%;
}
.dados-lider{
    width: 100%;
}


@media (min-width:310px) {
    
}

@media (min-width:368px) {

}

@media (min-width:600px) {
    
    .grupo-dados-nome-lider{
    display: flex;
    width: 100%;
    gap: 30px;
}
}

@media (min-width:801px) {

}

@media (min-width:1025px) { 

}

@media (min-width:1281px) { 
    
}

</style>
